import request from '../utils/fetch'
import { isObject } from 'lodash'
import qs from 'qs'

const ENTRY = '/relations-getchilds'

export const getRelationChildren = (pageSize, page, sorted, filtered) => {
  const sort = {}
  if (sorted && sorted.length > 0) {
    sort['childDeviceInfo.' + sorted[0].id] = sorted[0].desc ? -1 : 1
  }
  const filter = {}
  for (let index = 0; index < filtered.length; index++) {
    const { id, value } = filtered[index]
    let valueSended = value
    if (isObject(value)) {
      valueSended = value.value
    }
    if (valueSended!==undefined) filter[id] = valueSended
  }
  const tmp = qs.stringify({
    ...filter,
    $sort: sort,
    $skip: page * pageSize,
    $limit: pageSize,
    needRelationUserParent: 1,
    childrenType: 'device',
    $populate: {
      foreignField: '_id',
      localField: 'childrenId',
      ref: 'devices',
      path: 'childDeviceInfo',
      afterMatch: [{ $unwind: '$childDeviceInfo' }]
    }
  })
  return request(`${ENTRY}?${tmp}`, { method: 'GET' })
}

export const getAllRelationUser = _id => {
  const params = {
    childrenType: 'user'
  }
  if (_id) {
    params['childrenUserInfo._id'] = _id
  }
  const tmp = qs.stringify(params)
  return request(`${ENTRY}?${tmp}`, { method: 'GET' })
}
